// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class InputLinkService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public updateAudience<T>(params): Observable<T> {
    return this.sendService.put(this.Global.services.audience.update(), params);
  }
}
